import React from 'react';
import { motion } from 'framer-motion';
const problems = [{
  title: 'Llegás al entrenamiento sin saber qué trabajar',
  desc: 'Sin saber qué ejercicio o táctica vas a mejorar hoy.'
}, {
  title: 'Años en reserva sin dar el salto a primera',
  desc: 'Sin estructura clara para que el DT te tenga en cuenta.'
}, {
  title: 'Te lesionás seguido en los partidos',
  desc: 'Molestias musculares y articulares que no sabés cómo prevenir.'
}, {
  title: 'Siempre los mismos errores en cancha',
  desc: 'No sabés cómo corregirlos porque nadie te lo explicó bien.'
}, {
  title: 'La selección provincial inalcanzable',
  desc: 'Te falta un sistema de desarrollo estructurado y real.'
}, {
  title: 'Tips sueltos de Instagram y YouTube',
  desc: 'Sin un método claro que respalde tu progreso como jugador.'
}, {
  title: 'No sabés cómo estudiar tu propio juego',
  desc: 'Tu rendimiento varía partido a partido sin entender por qué.'
}, {
  title: 'Fin de temporada sin progreso visible',
  desc: 'Sin planificación real, la mejora es aleatoria y frustrante.'
}];
export function Problems() {
  return <section className="py-14 md:py-24 bg-rugby-green-900 relative" data-id="element-316">
      <div className="container mx-auto px-4" data-id="element-317">
        <div className="max-w-5xl mx-auto" data-id="element-318">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-16" data-id="element-319">
            <h2 className="text-3xl md:text-5xl font-display text-white mb-2 md:mb-4" data-id="element-320">
              ¿TE PASA ESTO?
            </h2>
            <p className="text-base md:text-xl text-slate-300 px-2" data-id="element-321">
              Si jugás rugby en Argentina, esto te suena familiar:
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-322">
            {problems.map((p, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} whileHover={{
            x: 4
          }} className="flex gap-3 md:gap-4 bg-rugby-green-950/50 p-3.5 md:p-6 rounded-xl border border-rugby-green-800/50 hover:border-red-900/60 transition-colors" data-id="element-323">
                <div className="mt-0.5 md:mt-1 flex-shrink-0" data-id="element-324">
                  <span className="text-base md:text-xl" data-id="element-325">🔴</span>
                </div>
                <div data-id="element-326">
                  <h3 className="text-sm md:text-lg font-bold text-white mb-0.5 md:mb-1 leading-snug" data-id="element-327">
                    {p.title}
                  </h3>
                  <p className="text-slate-400 text-xs md:text-sm leading-relaxed" data-id="element-328">
                    {p.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center bg-rugby-green-950 p-6 md:p-10 rounded-2xl border border-rugby-gold-500/20" data-id="element-329">
            <h3 className="text-xl md:text-4xl font-display text-rugby-gold-400 mb-1 md:mb-2" data-id="element-330">
              ¿Cuántas temporadas más vas a jugar
            </h3>
            <h3 className="text-xl md:text-4xl font-display text-white" data-id="element-331">
              sin dar el salto que merecés?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}